export default "__VITE_ASSET__6fa866b6__"